export const ONBOARDING_LAUNCH_SET_STEP = 'ONBOARDING_LAUNCH_SET_STEP';
export const ONBOARDING_SET_CONFIG = 'ONBOARDING_SET_CONFIG';
export const ONBOARDING_SET_CONFIG_DATA = 'ONBOARDING_SET_CONFIG_DATA';
export const ONBOARDING_SET_COUNTRY_CODE = 'ONBOARDING_SET_COUNTRY_CODE';
export const ONBOARDING_CLEAR_CONFIG_DATA = 'ONBOARDING_CLEAR_CONFIG_DATA';

export const onboardingSetConfig = (data) => ({
  type: ONBOARDING_SET_CONFIG,
  data,
});

export const onboardingClearConfig = () => ({
  type: ONBOARDING_CLEAR_CONFIG_DATA,
});

export const onboardingSetConfigData = (key, value) => ({
  type: ONBOARDING_SET_CONFIG_DATA,
  key,
  value,
});

export const onboardingSetActiveStep = (step) => ({
  type: ONBOARDING_LAUNCH_SET_STEP,
  payload: step,
});
